import { TenantConfig } from '@digital-platform/rs-shared/domain';

/**
 * Auth0 configuration for the LOWER environments.
 */
export const auth0LowerTenantConfig: TenantConfig = {
  domain: 'auth.awsdev.repsrv.com', // mr-dev-digital
  clientId: 'UpAEIKe3zfSboRP0cfaQ5EibYmljWYNS', // mr-dev-digital
  legacySameSiteCookie: false,
  cookieDomain: '.repsrv.com',
  useRefreshTokens: false,
  useRefreshTokensFallback: false,
  cacheLocation: 'localstorage',
  authorizationParams: {
    redirect_uri: (typeof window !== 'undefined'
      ? `${window.location.origin}` + '/auth'
      : undefined) as string,
    audience: 'https://rscom-rsa', // mr-dev-digital
  },
  // Leeway:60s is the default. Explicitely putting it here for clarity. This is the
  // threshold used by the getTokenSilently calls to fetch new tokens BEFORE the old ones expire.
  // – ie. if an idToken expires after 5 min, a value of 60 would force the auth0 sdk to request fresh tokens if we're at 4 minutes or greater
  leeway: 60,
  httpInterceptor: {
    allowedList: [
      {
        tokenOptions: {
          detailedResponse: true,
          cacheMode: 'on', // ON is what allows the httpInterceptor to only fetch just before expiration
        },
        // uri: '/api/*', // Example usage. This path match will have an ACCESS TOKEN added to the Authorization header
      },
    ],
  },
};

/**
 * Auth0 configuration for the PROD environment.
 */
export const auth0ProdTenantConfig: TenantConfig = {
  domain: 'my.republicservices.com',
  clientId: 'bkJ9bYB0BG0y5gCSST5WZ62O9ZSqSAbM',
  legacySameSiteCookie: false,
  cookieDomain: '.republicservices.com',
  useRefreshTokens: false,
  useRefreshTokensFallback: false,
  cacheLocation: 'localstorage',
  authorizationParams: {
    redirect_uri: (typeof window !== 'undefined'
      ? `${window.location.origin}` + '/auth'
      : undefined) as string,
    audience: 'https://rscom-rsa',
  },
  leeway: 60,
  httpInterceptor: {
    allowedList: [
      {
        tokenOptions: {
          detailedResponse: true,
          cacheMode: 'off',
        },
        // uri: '/api/*', // Example usage. This path match will have an ACCESS TOKEN added to the Authorization header
      },
    ],
  },
};
